type Props = {
  className?: string;
};
const SamsungTradeIn = ({ className = '' }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#000"
    className={className}
  >
    <path
      d="M13.3008 15H1.30078M5.50078 20.4002L1.48827 15.8108C1.23829 15.5249 1.23829 15.0639 1.48827 14.7779L5.48548 10.2002M10.3008 8.3999H21.7008M17.5008 3.6001L22.0865 7.91954C22.3722 8.18864 22.3722 8.62251 22.0865 8.89162L17.5183 13.2001"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SamsungTradeIn;
